<template>
  <header class="has-background-primary p-4">
    <h1 class="title has-text-white">Medibill</h1>
    
  </header>

</template>
